// Layout.js
import React from 'react';
import Navbar from './includes/Navbar';
import './../css/Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout-box">
      <Navbar />
      <div className="content flex-grow-1 p-3">
        {children}
      </div>
    </div>
  );
}

export default Layout;
